<template>
    <div class="apply-document-content">{{number}}</div>
     <!--<canvas id="apply-document-canvas"></canvas>-->
</template>
<script>
export default {
  name: "ApplyDocumentNumber",
  /*data() {
    return {
        canvas: null,
        context: null,
        number: "11932"
    };
  },*/
  computed: {
    number: function () {
       return this.$store.getters["domain/applyDocumentNumber"];
    }
  }
  /*mounted() {
    this.canvas = document.querySelector('#apply-document-canvas');
    this.context = this.canvas.getContext('2d');

    var widthValue = Number(this.canvas.clientWidth);
    var heigthValue = Number(this.canvas.clientHeight);
    var fontSize = Math.trunc(widthValue * heigthValue * 0.001);

    //this.contex.clearRect(0, 0, widthValue, heigthValue);

    this.context.font = `${fontSize}px sans-serif`;
    this.context.textAlign = 'center';
    this.context.fillText(this.number, widthValue/2, heigthValue/2);
  }*/
};
</script>
